import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faMoneyCheckDollar,
  faPaperPlaneTop,
  faUserTie
} from '@fortawesome/pro-solid-svg-icons'

export type ContactTypeKey =
  | 'typeDecisionMaker'
  | 'typeBilling'
  | 'typeActivePlacement'

export type ContactTypeFlags = Record<ContactTypeKey, boolean>

type ContactTypeDefinition = {
  key: ContactTypeKey
  label: string
  icon: IconDefinition
}

export const contactTypes: ContactTypeDefinition[] = [
  { key: 'typeDecisionMaker', label: 'Décisionnaire', icon: faUserTie },
  { key: 'typeBilling', label: 'Facturation', icon: faMoneyCheckDollar },
  {
    key: 'typeActivePlacement',
    label: 'Placement actif',
    icon: faPaperPlaneTop
  }
]

export const findFirstContactOfType = <T extends Partial<ContactTypeFlags>>(
  contacts: T[],
  type: ContactTypeKey
): T | undefined => contacts.find((contact) => contact[type] === true)
